import * as Yup from "yup";

export const ContactFormValidation = Yup.object().shape({
  first_name: Yup.string()
    .min(3, "cart.contact.form.validation.first_name_min_length")
    .max(50, "cart.contact.form.validation.first_name_max_length")
    .matches(/^[^0-9]*$/, "cart.contact.form.validation.first_name_no_numbers")
    .required("cart.contact.form.validation.first_name_required"),
  last_name: Yup.string()
    .min(3, "cart.contact.form.validation.last_name_min_length")
    .max(50, "cart.contact.form.validation.last_name_max_length")
    .matches(/^[^0-9]*$/, "cart.contact.form.validation.last_name_no_numbers")
    .required("cart.contact.form.validation.last_name_required"),
  email: Yup.string()
    .email("cart.contact.form.validation.email_invalid")
    .required("cart.contact.form.validation.email_required"),
  country_code: Yup.string().required(
    "cart.contact.form.validation.country_required"
  ),
  telephone: Yup.string()
    .test(
      "phone-validation",
      "cart.contact.form.validation.phone_invalid",
      function (value) {
        const { country_code } = this.parent;

        if (!value) {
          return this.createError({
            message: "cart.contact.form.validation.phone_required",
          });
        }

        if (country_code === "+423" && value.length !== 7) {
          return this.createError({
            message: "cart.contact.form.validation.phone_must_be_8_digits",
          });
        }

        if (country_code !== "+423" && value.length < 8) {
          return this.createError({
            message: "cart.contact.form.validation.phone_length",
          });
        }

        if (country_code !== "+423" && value.length > 11) {
          return this.createError({
            message: "cart.contact.form.validation.phone_length",
          });
        }

        return true;
      }
    )
    .required("cart.contact.form.validation.phone_required"),
});

export const OrderingMethodFormValidation = Yup.object().shape({
  ordering_method: Yup.string().required(
    "cart.ordering_method.delivery.form.validation.ordering_method_required"
  ),
  street_name: Yup.string().test(
    "street_name_required",
    "cart.ordering_method.delivery.form.validation.street_name_required",
    function (value) {
      const { ordering_method } = this.parent;
      if (ordering_method === "delivery") {
        return !!value;
      }
      return true;
    }
  ),
  area: Yup.string().test(
    "area_required",
    "cart.ordering_method.delivery.form.validation.area_required",
    function (value) {
      const { ordering_method } = this.parent;
      if (ordering_method === "delivery") {
        return !!value;
      }
      return true;
    }
  ),
  postal_code: Yup.string().test(
    "postal_code_required",
    "cart.ordering_method.delivery.form.validation.postal_code_required",
    function (value) {
      const { ordering_method } = this.parent;
      if (ordering_method === "delivery") {
        return !!value;
      }
      return true;
    }
  ),
  block_building: Yup.string().optional(),
  intercom: Yup.string().optional(),
  where_to_park: Yup.string().optional(),
});

export const PickUpMethodFormValidation = Yup.object().shape({
  method: Yup.string().required(
    "cart.available_time_choice.form.validation.method_required"
  ),
  date: Yup.string().test(
    "date_required",
    "cart.available_time_choice.form.validation.date_required",
    function (value) {
      const { method } = this.parent;
      if (method === "later") {
        return !!value;
      }
      return true;
    }
  ),
  time: Yup.string().test(
    "time_required",
    "cart.available_time_choice.form.validation.time_required",
    function (value) {
      const { method } = this.parent;
      if (method === "later") {
        return !!value;
      }
      return true;
    }
  ),
});

export const DeliveryMethodFormValidation = Yup.object().shape({
  method: Yup.string().required(
    "cart.available_time_choice.form.validation.method_required"
  ),
  date: Yup.string().test(
    "date_required",
    "cart.available_time_choice.form.validation.date_required",
    function (value) {
      const { method } = this.parent;
      if (method === "later") {
        return !!value;
      }
      return true;
    }
  ),
  time: Yup.string().test(
    "time_required",
    "cart.available_time_choice.form.validation.time_required",
    function (value) {
      const { method } = this.parent;
      if (method === "later") {
        return !!value;
      }
      return true;
    }
  ),
});

export const TableReservationAvailableTimeChoiceFormValidation =
  Yup.object().shape({
    date: Yup.date().required(
      "cart.available_time_choice.form.validation.date_required"
    ),
    time: Yup.string().required(
      "cart.available_time_choice.form.validation.time_required"
    ),
  });

export const DineInMethodFormValidation = Yup.object().shape({
  table_no: Yup.string().required(
    "cart.table_number.form.validation.table_number_required"
  ),
});

export const TableReservationMethodFormValidation = Yup.object().shape({
  person: Yup.string().required(
    "cart.table_size.form.validation.persons_required"
  ),
});

export const PaymentMethodFormValidation = Yup.object().shape({
  method: Yup.string().required(
    "cart.payment_method.form.validation.payment_method_required"
  ),
});

export const TableReservationValidation = Yup.object().shape({
  person: Yup.string().required(
    "cart.table_size.form.validation.persons_required"
  ),
  date: Yup.string().required(
    "cart.available_time_choice.form.validation.date_required"
  ),
  time: Yup.string().required(
    "cart.available_time_choice.form.validation.time_required"
  ),
  seating_preference: Yup.string().required(
    "cart.seating_preference.validation.seating_preference_required"
  ),
  comments: Yup.string().optional(),
});
